<script setup lang="ts">
import { computed, ref } from 'vue';
import type { UiThinkingBlock } from '@/stores/chat';

const props = defineProps<{ blocks: UiThinkingBlock[]; streaming: boolean }>();
const open = ref(false);

const running = computed(() => props.blocks.some((b) => b.running));
const withText = computed(() => props.blocks.filter((b) => b.text.trim()));
/** Laatste regel van de laatste overdenking (max. 160 tekens) — live zichtbaar als ingeklapt. */
const lastLine = computed(() => {
  const last = withText.value.at(-1)?.text.trim() ?? '';
  const line = last.split('\n').filter(Boolean).at(-1) ?? '';
  return line.length > 160 ? `${line.slice(0, 160)}…` : line;
});
const totalMs = computed(() => props.blocks.reduce((s, b) => s + (b.durationMs ?? 0), 0));
</script>

<template>
  <div v-if="blocks.length" class="kl-chat-thinking" :class="{ open }" data-testid="chat-thinking">
    <button type="button" class="kl-chat-thinking-head" :aria-expanded="open" @click="open = !open">
      <span v-if="running" class="spinner-border spinner-border-sm" aria-hidden="true"></span>
      <i v-else class="bi bi-lightbulb" aria-hidden="true"></i>
      <span class="fw-medium">{{ running ? 'Aan het nadenken…' : 'Overdenking' }}</span>
      <span v-if="!running && totalMs" class="text-muted">({{ Math.round(totalMs / 1000) }} s)</span>
      <span v-if="!open && lastLine" class="kl-chat-thinking-last text-muted">{{ lastLine }}</span>
      <i class="bi ms-auto" :class="open ? 'bi-chevron-up' : 'bi-chevron-down'" aria-hidden="true"></i>
    </button>
    <div v-if="open" class="kl-chat-thinking-body">
      <template v-if="withText.length">
        <div v-for="(b, i) in withText" :key="i" class="kl-chat-thinking-step">
          <div v-if="withText.length > 1" class="small text-muted">Stap {{ i + 1 }}</div>
          <div class="kl-chat-thinking-text">{{ b.text }}</div>
        </div>
      </template>
      <div v-else class="text-muted small">De redenering is niet zichtbaar gemaakt door het model.</div>
    </div>
  </div>
</template>
